import { useState } from 'react'
import { Modal, Button, Checkbox } from '@mantine/core'
import classNames from 'classnames'
import Box from '@/components/ui/Box'
import useServiceReasons from '@/hooks/useServiceReasons'

export default function ServiceCaseReasons({ serviceCase, updateServiceCase }) {
    const [opened, setOpened] = useState(false)
    const [selectedIds, setSelectedIds] = useState([])
    const [loading, setLoading] = useState(false)

    const { reasonGroups, reasons } = useServiceReasons()

    const activeReasonIds = (serviceCase.service_reasons || []).map((r) => r.id)

    const handleOpen = () => {
        setSelectedIds([...activeReasonIds])
        setOpened(true)
    }

    const toggle = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        )
    }

    const handleSave = async () => {
        setLoading(true)
        await updateServiceCase({ service_reasons: selectedIds })
        setLoading(false)
        setOpened(false)
    }

    return (
        <>
            <Box
                title="Raisons"
                globalAction={true}
                action={handleOpen}
                actionLabel="Modifier les raisons"
            >
                {serviceCase.service_reasons?.length ? (
                    <div className="flex flex-col gap-1.5">
                        {serviceCase.service_reasons.map((reason) => (
                            <div
                                key={reason.id}
                                className="flex items-center gap-2 text-sm"
                            >
                                <span className="text-gray-400">
                                    {reason.group?.name}
                                </span>
                                <span className="text-gray-300">/</span>
                                <span>{reason.name}</span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <span className="text-gray-500">Aucune raison</span>
                )}
            </Box>

            <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                title="Raisons du retour"
                centered
                keepMounted={false}
            >
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-4 max-h-[500px] overflow-y-auto">
                        {reasonGroups.map((group) => (
                            <div key={group.id}>
                                <span className="text-xs font-medium text-gray-400 uppercase tracking-wide">
                                    {group.name}
                                </span>
                                <div className="flex flex-col gap-1 mt-1.5">
                                    {group.service_reasons.map((reason) => (
                                        <div
                                            key={reason.id}
                                            className={classNames(
                                                'border rounded-lg p-3 cursor-pointer transition-colors flex items-center gap-3',
                                                {
                                                    'border-blue-500 bg-blue-50':
                                                        selectedIds.includes(
                                                            reason.id
                                                        ),
                                                    'border-gray-200 hover:bg-gray-50':
                                                        !selectedIds.includes(
                                                            reason.id
                                                        ),
                                                }
                                            )}
                                            onClick={() => toggle(reason.id)}
                                        >
                                            <Checkbox
                                                checked={selectedIds.includes(
                                                    reason.id
                                                )}
                                                onChange={() => {}}
                                                readOnly
                                            />
                                            <span className="text-sm">
                                                {reason.name}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <Button onClick={handleSave} fullWidth loading={loading}>
                        Enregistrer
                    </Button>

                    <p className="text-center text-xs text-red-500">
                        Les raisons sont définies par le service client.
                    </p>
                </div>
            </Modal>
        </>
    )
}
